import React, { useState, useEffect } from "react";
import Footer from "./Footer";
import Header from "./Header/Header";
import HeroSection from "./HeroSection";
import "./DESetup.scss";
import PopularLaws from "./PopularLaws";
import HistoricalLaws from "./HistoricalLaws";
import LatestLaws from "./LatestLaws";
import JointResolutionLaws from "./JointResolutionLaws";
import { checkStaffAccess } from "../../../apis/checkStaffAccess";
import { getLatestLaws } from "../../../apis/getLatestLaws";
import { getPopularAndHistory } from "../../../apis/getPopularAndHistory";
import { getTemplate } from "../../../apis/getTemplate";
import { postAnalysis } from "../../../apis/postAnalysis";
import DownloadList from "../../ReuseableComponents/DownloadList/DownloadList";
import PageLoader from "../../ReuseableComponents/Loader/PageLoader";

type Props = {};

const DESetup = (props: Props) => {
  const [isStaff, setIsStaff] = useState<any>();
  const [latestLaw, setLatestLaws] = useState<any>();
  const [latestJoint, setLatestJoints] = useState<any>();
  const [popularLaw, setPopularLaws] = useState<any>();
  const [historyrLaw, setHistoryLaws] = useState<any>();
  const [webTemplate, setWebTemplate] = useState<any>();
  const [loading, setLoading] = useState(true);

  const [error, setError] = useState("");
  const [cursor, setCursor] = useState("");
  const [demandLoading, setDemandLoading] = useState(false);

  const [disabledButtons, setDisabledButtons] = useState<any>([]);
  
  const handleButtonClick = (items: any) => {
    if (disabledButtons.length < 3) {
      setDisabledButtons(
        (prevDisabledButtons: { doc_id: string; documentName: string }[]) => [
          ...prevDisabledButtons,
          { doc_id: items.doc_id, documentName: items.name, Created: items.created, CreatedBy: items.created_by, Modified: items.modified, ModifiedBy: items.modified_by, Pages: items.pages, Documento: items.type, NumLey: items.law_number, Year: items.year, Caja: "1830", Titulo: "", Tipo: "Original", Estatus: items.status, Fecha: items.date, NombreAgencia: items.agency, Municipio: items.municipality },
        ]
      );
    } else {
      setError("Range Exceeded");
    }
  };

  useEffect(() => {
    if (disabledButtons.length < 3) {
      setError("");
      setCursor("");
    } else {
      setCursor("not-allowed");
    }
  }, [disabledButtons]);

  const handleRemove = (itemToRemove: any) => {
    const updatedButtons = disabledButtons.filter(
      (item: any) => item !== itemToRemove
    );
    setDisabledButtons(updatedButtons);
  };

  useEffect(() => {
    const homePageHit = {
      home: true,
      search: false,
    };
    postAnalysis(homePageHit)
      .then((userData) => {
        console.log(userData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    checkStaffAccess()
      .then((staff) => {
        setIsStaff(staff);
      })
      .catch((err) => {
        console.log(err);
      });
    getLatestLaws()
      .then((L) => {
        setLatestLaws(L?.latest_laws);
        setLatestJoints(L?.joint_resolutions);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
    getPopularAndHistory()
      .then((PH) => {
        setPopularLaws(PH?.popular_documents);
        setHistoryLaws(PH?.historical_documents);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
    getTemplate()
      .then((Template) => {
        setWebTemplate(Template);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [isStaff, loading]);

  return (
    <>
      <Header />
      <div className="DE-Container">
        <HeroSection
          isStaff={isStaff}
          webTemplate={webTemplate}
          loading={loading}
          setLoading={setLoading}
        />
        <LatestLaws
          isStaff={isStaff}
          latestLaw={latestLaw}
          loading={loading}
          webTemplate={webTemplate}
          setLoading={setLoading}
          handleButtonClick={handleButtonClick}
          disabledButtons={disabledButtons}
          cursor={cursor}
        />
        <JointResolutionLaws
          isStaff={isStaff}
          latestJoint={latestJoint}
          loading={loading}
          webTemplate={webTemplate}
          setLoading={setLoading}
          handleButtonClick={handleButtonClick}
          disabledButtons={disabledButtons}
          cursor={cursor}
        />
        <PopularLaws
          isStaff={isStaff}
          popularLaw={popularLaw}
          loading={loading}
          webTemplate={webTemplate}
          setLoading={setLoading}
          handleButtonClick={handleButtonClick}
          disabledButtons={disabledButtons}
          cursor={cursor}
        />
        <HistoricalLaws
          isStaff={isStaff}
          historyrLaw={historyrLaw}
          loading={loading}
          webTemplate={webTemplate}
          setLoading={setLoading}
          handleButtonClick={handleButtonClick}
          disabledButtons={disabledButtons}
          cursor={cursor}
        />
        <Footer />
      </div>
      <DownloadList
        disabledButtons={disabledButtons}
        setDisabledButtons={setDisabledButtons}
        handleRemove={handleRemove}
        error={error}
        demandLoading={demandLoading}
        setDemandLoading={setDemandLoading}
      />
      {demandLoading ? <PageLoader /> : ""}
    </>
  );
};

export default DESetup;
